let cachedUserSelectionText: string;
export function updateUpsellUserSelectionText(selectionText: string | undefined) {
    cachedUserSelectionText = selectionText;
}

export function getUpsellUserSelectionText() {
    return cachedUserSelectionText;
}
